'use strict';

/*
 * Android Cordova/WebView can fail to run CSS/SVG spinner animations reliably.
 * Keep this Cordova-only and drive known spinner shells with requestAnimationFrame.
 */

const SELECTORS = [
    '.MuiCircularProgress-root',
    '.nearpeer-loading-screen__spinner',
    '.nearpeer-cordova-boot__spinner',
    '[data-nearpeer-spinner]'
];

const internals = {};

internals.isCordovaLike = () => {

    if (typeof window === 'undefined') {
        return false;
    }

    const userAgent = window.navigator?.userAgent || '';

    return !!window.cordova
        || (/Android/i.test(userAgent) && /; wv\)/i.test(userAgent));
};

internals.start = () => {

    if (!internals.isCordovaLike() || window.__nearpeerCordovaSpinnerRafStarted) {
        return;
    }

    window.__nearpeerCordovaSpinnerRafStarted = true;

    let angle = 0;
    let frame = 0;
    let nodes = [];

    const refreshNodes = () => {

        nodes = SELECTORS.flatMap((selector) => Array.from(document.querySelectorAll(selector)))
            .filter((node, index, all) => node && all.indexOf(node) === index);
    };

    const tick = () => {

        frame += 1;
        angle = (angle + 4) % 360;

        if (frame === 1 || frame % 20 === 0) {
            refreshNodes();
        }

        nodes.forEach((node) => {

            if (!node.isConnected) {
                return;
            }

            node.style.animation = 'none';
            node.style.webkitAnimation = 'none';
            node.style.transformOrigin = '50% 50%';
            node.style.webkitTransformOrigin = '50% 50%';
            node.style.willChange = 'transform';
            node.style.transform = `translateZ(0) rotate(${angle}deg)`;
            node.style.webkitTransform = `translateZ(0) rotate(${angle}deg)`;
        });

        window.requestAnimationFrame(tick);
    };

    window.requestAnimationFrame(tick);
};


if (typeof window !== 'undefined') {
    internals.start();
}
